import type { AxiosError } from 'axios';

export const NETWORK_ERROR_CODES = ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'];
export const CLIENT_ACCESS_ERROR_CODES = [403, 404];

export function normalizeErrorToI18n(
  error: unknown,
): { statusCode?: number;
    key: I18nKeys;
  } {
  if (typeof error === 'object' && error !== null && 'statusCode' in error) {
    const nuxtError = error as {
      statusCode?: number;
      statusMessage?: string;
    };

    return {
      statusCode: nuxtError.statusCode,
      key: mapStatusToKey(nuxtError.statusCode),
    };
  }

  // Axios error
  if ((error as AxiosError)?.isAxiosError) {
    const axiosError = error as AxiosError;
    const statusCode = axiosError.response?.status;

    if (axiosError.code && NETWORK_ERROR_CODES.includes(axiosError.code)) {
      return { key: 'errors.network.unavailable' };
    }

    return {
      statusCode,
      key: mapStatusToKey(statusCode),
    };
  }

  // Fallback
  return { key: 'errors.unknown' };
}

function mapStatusToKey(
  status?: number,
): I18nKeys {
  if (!status) return 'errors.unknown';

  if (status === 403) return 'errors.auth.forbidden';
  if (status === 404) return 'errors.http.notFound';

  if (status >= 500) return 'errors.http.server';
  if (status >= 400) return 'errors.http.client';

  return 'errors.unknown';
}
